module.exports = __webpack_public_path__ + "img/Pria.191abfce.svg";